"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lineColFromIndex = lineColFromIndex;

/**
 * Determines line and column number of character index in source code.
 */
function lineColFromIndex(source, index) {
  var lines = source.slice(0, index).split(/\n/);
  return {
    line: lines.length,
    col: lines[lines.length - 1].length + 1
  };
}
//# sourceMappingURL=lineColFromIndex.js.map